import _implicitStylesheets from "./pageHeader.css";

import _implicitScopedStylesheets from "./pageHeader.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {h: api_element, t: api_text} = $api;
  return [api_element("div", {
    classMap: {
      "slds-page-header": true,
      "header-bottom__align": true
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "slds-page-header__row": true
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-page-header__col-title": true
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "slds-media": true
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "slds-media__figure": true
    },
    key: 4
  }, [api_element("img", {
    classMap: {
      "header-icon": true
    },
    attrs: {
      "alt": "smax-icon",
      "src": "/resources/smax-x.png",
      "title": "smax logo"
    },
    key: 5
  }, [])]), api_element("div", {
    classMap: {
      "slds-media__body": true
    },
    key: 6
  }, [api_element("div", {
    classMap: {
      "slds-page-header__name": true
    },
    key: 7
  }, [api_element("div", {
    classMap: {
      "slds-page-header__name-title": true
    },
    key: 8
  }, [api_element("p", {
    classMap: {
      "slds-page-header__name-meta": true
    },
    key: 9
  }, [api_text("Asset 360 Tooling")]), api_element("h1", {
    key: 10
  }, [api_element("span", {
    classMap: {
      "slds-page-header__title": true,
      "slds-truncate": true
    },
    attrs: {
      "title": "Configuration Migration"
    },
    key: 11
  }, [api_text("Configuration Migration")])])])])])])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-pageHeader_pageHeader"
